
    <div *ngIf="visible" class="pwx-bar"
         [class.pwx-warning]="level === 'warning'"
         [class.pwx-critical]="level === 'critical' || level === 'expired'"
         [attr.role]="level === 'critical' || level === 'expired' ? 'alert' : 'status'">
      <span class="pwx-icon" aria-hidden="true"><i class="fa" [ngClass]="iconClass"></i></span>
      <span class="pwx-text">
        <span class="pwx-headline">{{ headline }}</span>
        <span class="pwx-detail">{{ detail }}</span>
      </span>
      <a class="pwx-btn" [routerLink]="['/user-profile']" [queryParams]="{ changePassword: true }">
        <span class="pwx-btn-long">Change password</span>
        <span class="pwx-btn-short">Update</span>
      </a>
    </div>
  